import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import store from './store'
import directives from './directives'

import Keycloak from 'keycloak-js';
import config from './config.js';

import './assets/dagobah-ui.css';

Vue.config.productionTip = false


let initOptions = {
  url: config.AUTH_URL,
  realm: config.AUTH_REALM,
  clientId: config.AUTH_CLIENT_ID,
  onLoad:'login-required'
}

let keycloak = Keycloak(initOptions);

console.log('[KEYCLOAK] Init');

keycloak.init({ 
  checkLoginIframe: false,
//  messageReceiveTimeout: 2000,
//  enableLogging: true,
  onLoad: initOptions.onLoad
})
  .then((auth) =>{
      console.log('[KEYCLOAK] Init then');

      if(!auth) {
      window.location.reload();
    } else {
      console.log('[KEYCLAOK] Authenticated');
    }
 
    new Vue({
      router,
      i18n,
      directives,
      store,
      render: h => h(App)
    }).$mount('#app')  

    console.log("keycloak.tokenParsed.preferred_username = ", keycloak.tokenParsed.preferred_username);
    store.commit('login', {
      email: keycloak.tokenParsed.preferred_username,
      token: keycloak.token,
      refreshToken: keycloak.refreshToken,
      logout: () => {
        console.log('[KEYCLAOK] [Logout] keycloak.tokenParsed.preferred_username = ', keycloak.tokenParsed.preferred_username);
        keycloak.logout()
          .then(() => {
            window.location.reload();
          });
      }
    });

    // localStorage.setItem("vue-token", keycloak.token);
    // localStorage.setItem("vue-refresh-token", keycloak.refreshToken);

    setInterval(() =>{
      // console.log("[KEYCLOAK] this.$store.state.identityIdentified = ", this.$store.state.identityIdentified);
      // keycloak.updateToken(250)
      keycloak.updateToken(70)
        .then((refreshed)=>{
          if (refreshed) {
            store.commit('login', {
              email: keycloak.tokenParsed.preferred_username,
              token: keycloak.token,
              refreshToken: keycloak.refreshToken,
              keepSelectedProject: true,
              logout: () => {
                console.log('[KEYCLAOK] [Logout] keycloak.tokenParsed.preferred_username = ', keycloak.tokenParsed.preferred_username);
                keycloak.logout()
                  .then(() => {
                    window.location.reload();
                  });
              }
            });
            console.log('[KEYCLAOK] Token refreshed'+ refreshed);
            // console.log("store.state.identityIdentified.token = ", store.state.identityIdentified.token);
            // console.log("keycloak.token = ", keycloak.token);
            // console.log("keycloak.refreshToken = ", keycloak.refreshToken);
            // console.log("keycloak.tokenParsed.preferred_username = ", keycloak.tokenParsed.preferred_username);
          } else {
            // console.log('[KEYCLAOK] Token not refreshed, valid for '
            // + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
          }
        })
        .catch(()=>{
          console.log('[KEYCLAOK] [ERROR] Failed to refresh token');

          // redirect to login page when refresh token failed
          // this action could display the security exception to authorize for self-signed https requests
          keycloak.login();
        });
    }, 60000)

  })
  .catch(() =>{
      console.log('[KEYCLOAK] Init catch');

      console.log('[KEYCLAOK] [ERROR] Authenticated Failed');

      // redirect to login page when init failed
      // this action could display the security exception to authorize for self-signed https requests
      keycloak.login();
  });



